import Vue from 'vue';
import Success from "@comp/Success.vue";

const MessagePlugin = {};
let instance = null;

MessagePlugin.install = function (Vue, options) {
    const MessageComponent = Vue.extend(Success);


    Vue.prototype.$message = {
        error(message) {
            if (!instance) {
                // 找到所有拥有特定类名的元素
                instance = new MessageComponent({
                    propsData: {
                        message,
                    },
                });
            }


            instance.$mount();
            document.getElementsByClassName("main")[0].appendChild(instance.$el);

            instance.error(message);
        },
        success(message) {
            if (!instance) {
                // 找到所有拥有特定类名的元素
                instance = new MessageComponent({
                    propsData: {
                        message,
                    },
                });
            }

            instance.$mount();
            document.getElementsByClassName("main")[0].appendChild(instance.$el);

            instance.success(message);
        }
    };
};

export default MessagePlugin;
